export const getAll = state => {
  return state.all;
};

export const getOptions = state => {
  let options = [];
  getAll(state).forEach(element => {
    let name = element.name;
    if (element._parent && element._parent.name)
      name = `${element._parent.name}: ${element.name}`;
    options.push({ text: name, id: element._id, type: element.type });
  });
  return options;
};
